import { Component, DestroyRef, inject, Input } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { EMPTY, of } from "rxjs";
import { switchMap } from "rxjs/operators";
import { DcAlertInnerService } from "src/app/ui-kit/dc-alert-inner/dc-alert-inner.service";
import { NotificationsService } from "../../notifications/notification.service";
import { WorkflowMessage, WorkflowMessageContext, WorkflowMessageTarget } from "./workflow-handler.const";

@Component({ template: '' })
export abstract class WorkflowMessageHandler {

    protected notificationService = inject(NotificationsService);
    
    protected destroyRef = inject(DestroyRef);

    @Input({ transform: (value: string) => Number(value) })
    productId: number;

    protected dcAlertInnerService = inject(DcAlertInnerService);

    constructor() {
        this.notificationService.onMessage$
            .pipe(
                takeUntilDestroyed(this.destroyRef),
                switchMap((message: WorkflowMessage) => message.productId ? of(message) : EMPTY)
            )
            .subscribe(this.handleMessage.bind(this));
    }

    handleMessage(workflowMessage: WorkflowMessage): void {
        const { context, targets, message, productId } = workflowMessage;
        if (context !== this.context || Number(productId) !== this.productId) {
            return;
        }

        if (targets === WorkflowMessageTarget.ERROR_MODAL) {
            this.dcAlertInnerService.showAlert({ type: 'danger', message });
        } else if (targets === WorkflowMessageTarget.DATA_REFRESH) {
            this.refreshData();
        }
    }

    abstract refreshData(): void;
    
    abstract get context(): WorkflowMessageContext;
}